import { render, staticRenderFns } from "./403.vue?vue&type=template&id=cb8a2b14&scoped=true"
import script from "./403.vue?vue&type=script&lang=ts"
export * from "./403.vue?vue&type=script&lang=ts"
import style0 from "./403.vue?vue&type=style&index=0&id=cb8a2b14&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8a2b14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb8a2b14')) {
      api.createRecord('cb8a2b14', component.options)
    } else {
      api.reload('cb8a2b14', component.options)
    }
    module.hot.accept("./403.vue?vue&type=template&id=cb8a2b14&scoped=true", function () {
      api.rerender('cb8a2b14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/error-page/403.vue"
export default component.exports